export function getEventIdsFromConfiguration(config) {
    const eventIds = {
        All: [],
        Outrights: []
    };
    /* istanbul ignore next */
    if (config.SuperBannerItems) {
        config.SuperBannerItems.forEach(item => {
            /* istanbul ignore next */
            if (item.PickedEvent) {
                if (item.PickedEvent.IsOutright || item.PickedEvent.IsQA) {
                    eventIds.Outrights.push(item.PickedEvent.EventID);
                    eventIds.All.push(item.PickedEvent.EventID);
                }
                else {
                    eventIds.All.push(item.PickedEvent.MasterEventID);
                }
            }
        });
    }
    return eventIds;
}
//# sourceMappingURL=SuperBannerConfigurationHelper.js.map